module.exports = __webpack_public_path__ + "img/close-orange.4d7aac9d.svg";